import { put, call } from "redux-saga/effects";
import {       GET_EMPLOYEEINFO_SUCESS,GET_EMPLOYEEINFO_FAILED 
} from "../actions/Manageuser";
import { UserAPI } from "../../utils/api/CreateUserAPI";
export function*getAllEmployeeInfoDetails (request:any) {
    try {
        const { data } = yield call(UserAPI.userDetailByTenant,request);
 
      yield put({
          type: GET_EMPLOYEEINFO_SUCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_EMPLOYEEINFO_FAILED, payload: e.message });
    }
}